import { Globe, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/context/LanguageContext";
import { languageNames, languageFlags } from "@/translations";

// Language Selector Component
export const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-2 px-3 py-2 rounded-full transition-all hover:scale-105"
          style={{ backgroundColor: 'rgba(163, 177, 138, 0.2)', color: '#1A3C34' }}
          data-testid="language-selector"
        >
          <Globe className="w-4 h-4" />
          <span className="font-body text-sm">{languageFlags[language]} {languageNames[language]}</span>
          <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {Object.keys(languageNames).map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => changeLanguage(lang)}
            className={`cursor-pointer ${language === lang ? 'bg-accent' : ''}`}
            data-testid={`lang-option-${lang}`}
          >
            <span className="mr-2">{languageFlags[lang]}</span>
            {languageNames[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
